import React from 'react';
import { graphql } from 'gatsby';
import Container from '@atoms/Container';
import PageTitle from '@atoms/PageTitle';
// import Breadcrumbs from '@sections/Breadcrumbs';
import RichTextEditorStyles from '@utils/RichTextEditorStyles';
import paddingDefault from '@utils/paddingDefault';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import Link from "../primitives/link";
import { colors } from '../primitives/colors';

const IngredientsDisclosure = ({ data }) => {
    const { heading, copy, ingredients } = data;

    return (
        <Container css={paddingDefault()}>
            {/* <div css={styles.breadcrumbsWrap}>
                <Breadcrumbs />
            </div> */}
            <div css={styles.pageTitleWrap}>
                <PageTitle>{apCaseOnlyTitleTags(heading)}</PageTitle>
            </div>
            <div
                css={[RichTextEditorStyles, styles.copy]}
                dangerouslySetInnerHTML={{ __html: copy }}
            />
            <ul css={styles.ingredientsList}>
                {ingredients.map(ingredient => {
                    const { label, disclosure_file, safety_datasheet_file } = ingredient;

                    return (
                        <li css={styles.lineWrap} key={label}>
                            <p>{label}</p>
                            <div css={styles.linkWrap}>
                                {disclosure_file?.url && (
                                    <Link css={styles.linkItem} to={disclosure_file.url}>
                                        Ingredients Disclosure
                                    </Link>
                                )}
                            </div>
                            <div css={styles.linkWrap}>
                                {safety_datasheet_file?.url && (
                                    <Link css={styles.linkItem} to={safety_datasheet_file.url}>
                                        Safety Data Sheet
                                    </Link>
                                )}
                            </div>
                        </li>
                    )
                })}
            </ul>
        </Container>
    );
};

const styles = {
    linkItem: {
        color: colors.primaryOrange,
        textDecoration: "underline",
    },
    linkWrap: {
        ':last-of-type': {
            '@media (min-width: 1024px)': {
                marginLeft: "40px"
            }
        }
    },
    lineWrap: {
        position: "relative",
        display: "grid",
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        rowGap: "0.5rem",
        paddingTop: "2.25rem",
        paddingBottom: "2.75rem",
        fontSize: "1.25rem",
        lineHeight: "1.5rem",
        "@media (min-width: 1024px)": {
            rowGap: "1rem",
            gridTemplateColumns: "630px 1fr 1fr",
        },
        "@media (min-width: 1280px)": {
            rowGap: "0"
        },
        "::before,::after": {
            content: "''",
            height: "1px",
            backgroundColor: colors.primaryOrange,
            display: "block",
            position: "absolute",
            right: "0",
            left: "0"
        },
        "::before": {
            top: 0
        },
        "::after": {
            bottom: "-1px"
        }
    },
    copy: {
        marginBottom: "4rem",
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        a: {
            color: colors.primaryOrange,
            textDecoration: "underline"
        }
    },
    breadcrumbsWrap: {
        "@media (min-width: 1024px)": {
            "marginBottom": "0.75rem"
        }
    },
    pageTitleWrap: {
        "marginBottom": "2.5rem",
        "maxWidth": "42rem",
        "lineHeight": 1
    },
    ingredientsList: {
        "fontSize": "1.125rem",
        "lineHeight": "1.75rem",
        "fontWeight": 600
    }
};

export const query = graphql`
  fragment IngredientsDisclosureData on CmsPageBuilderBlocks {
    ingredients_disclosure {
      heading
      copy
      ingredients {
        label
        disclosure_file {
          url
        }
        safety_datasheet_file {
          url
        }
      }
    }
  }
`;

export default IngredientsDisclosure;
